var map = {
	"./RESTURANT1.jpg": 4555,
	"./RESTURANT2.jpg": 3036,
	"./RESTURANT3.jpg": 7385,
	"./RESTURANT4.jpg": 1642,
	"./RESTURANT5.jpg": 3799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4168;